{
  "carrierLabel": "บริษัทขนส่ง",
  "searchPlaceholder": "ค้นหาตามชื่อ",
  "selectAsCarrier": "เลือก \"{name}\" เป็นผู้ขนส่ง",
  "typeToSearch": "พิมพ์เพื่อค้นหาบริษัท"
}
